import { Container, Flex } from "@mantine/core";
import cx from "classnames";
import Link from "next/link";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { FOOTER_MENU_PATH } from "src/const";
import { FREE_USER_FOOTER_MENU_PATH } from "src/const/paths";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

import styles from "./FooterMenu.module.scss";

export const FooterMenu: FC = () => {
  const { data: user } = useGetUserSettingsQuery();
  const [active, setActive] = useState(0);
  const [navItemProps, serNavItemsProps] = useState<
    {
      href: string;
      icon: any;
      label: string;
    }[]
  >([]);

  // 権限でメニューの内容を変更
  useEffect(() => {
    if (user) {
      const role = user.role;
      if (role === "FREE_USER") {
        return serNavItemsProps([...FREE_USER_FOOTER_MENU_PATH]);
      } else {
        return serNavItemsProps([...FOOTER_MENU_PATH]);
      }
    } else {
      serNavItemsProps([...FREE_USER_FOOTER_MENU_PATH]);
    }
  }, [user]);

  const navItems = navItemProps.map((navItem, index) => {
    return (
      <div key={index} className={styles.linkWrap}>
        {navItem.label === "部室" ? (
          <Link
            href={navItem.href}
            target="_blank"
            rel="noopener noreferrer"
            passHref
            aria-label={`${navItem.label}へ遷移`}
            className={cx(styles.link, {
              [styles.linkActive]: index === active,
            })}
            onClick={() => {
              setActive(index);
            }}
          >
            <div>
              <navItem.icon
                size={24}
                className={cx(styles.icon, {
                  [styles.iconActive]: index === active,
                })}
              />
            </div>
            {navItem.label}
          </Link>
        ) : (
          <Link
            href={navItem.href}
            passHref
            aria-label={`${navItem.label}へ遷移`}
            className={cx(styles.link, {
              [styles.linkActive]: index === active,
            })}
            onClick={() => {
              setActive(index);
            }}
          >
            <div>
              <navItem.icon
                size={24}
                className={cx(styles.icon, {
                  [styles.iconActive]: index === active,
                })}
              />
            </div>
            {navItem.label}
          </Link>
        )}
      </div>
    );
  });
  return (
    <Container className={styles.footer}>
      <Flex
        align="center"
        justify="center"
        maw={710}
        mx="auto"
        className={styles.inner}
      >
        {navItems}
      </Flex>
    </Container>
  );
};
